<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Pharmacies",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Pharmacies",
            items: [
               {
                  text: "Pharmacies",
                  active: true,
               },                   
            ],

            pharmacies: [],
            pharmacy_status: {
               id: "",
               status: "",
            },
            limit: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            pagination: {},
            from: "",
            to: "",
            total: "",

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchPharmacies();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         
         fetchPharmacies(page_url = null){

            this.getToken();

            let url = "clinic/clinic/pharmacies?limit=" + this.limit + "&status=" + this.status + "&keyword=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var data = res.data.data;
                  console.log(data);

                  this.pharmacies = data.data;
                  this.from = data.from;
                  this.to = data.to;
                  this.total = data.total;
                  this.pagination = data.links;

               })
               .catch((error) => {

                  if (error.response) {
                     if (error.response.data.message) {

                        if (typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     }
                     else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }

               })
               .finally(() => (this.loading = false));


         },


         changePharmacyStatus(pharmacy_id, status){

         this.getToken();
         let url = "clinic/clinic/pharmacy/status?id=" + pharmacy_id + "&status=" + status;
         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchPharmacies();
               this.$router.push({ name: 'pharmacies' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchPharmacies();
         },

         pharmacyDelete(pharmacy) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this pharmacy account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     let url = "clinic/clinic/deletePharmacy?pharmacy_id=" + pharmacy.id;

                     this.$axios
                        .get(url, { headers: { Authorization: "Bearer " + this.token } })
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchPharmacies();
                           this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

          getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },


         formatDate(dateString) {
			const date = new Date(dateString);

			const day = date.getDate();
			const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
			const year = date.getFullYear();

			const hours = date.getHours();
			const minutes = date.getMinutes();

			return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
		},

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">                        
                        <router-link :to="{ name: 'pharmacies.add' }" class="btn btn-primary float-end">Add Pharmacy</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="limit" @change="fetchPharmacies()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchPharmacies()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchPharmacies()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="15%">Name</th>  
                              <th width="15%">Place</th> 
                              <th width="15%">Phone</th>
                              <th width="15%">Created On</th>
                              <th width="30%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(pharmacies.length)">
                           <tr v-for="(pharmacy) in pharmacies" :key="pharmacy.id">
                              <td>{{ pharmacy.pharmacy_name }}</td>
                              <td>{{ pharmacy.address }}</td>
                              <td>{{ pharmacy.mobile }}</td>
                              <td>{{ formatDate(pharmacy.created_at) }}</td>
                              <td>
                                 <router-link :to="{ name: 'pharmacies.details' , params: { id: pharmacy.id }}"
                                 class="btn btn-primary btn-sm me-2 mb-2">Profile</router-link>
                                 <router-link :to="{ name: 'pharmacies.edit', params: { id: pharmacy.id }}" 
                                 class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
                                 <router-link :to="{ name: 'pharmacies.bookings', params: { id: pharmacy.id }}"
                                 class="btn btn-primary btn-sm me-2 mb-2">Bookings</router-link>
                                 <router-link :to="{ name: 'pharmacies.counters', params: { id: pharmacy.id }}"
                                  class="btn btn-primary btn-sm me-2 mb-2">Counters</router-link>
                                 <router-link :to="{ name: 'module.tvs', params: { id: pharmacy.id, module: 'pharmacy' }}"
                                  class="btn btn-primary btn-sm me-2 mb-2">TVs</router-link>
                                 <router-link :to="{ name: 'pharmacies.outsource-token-calls', params: { id: pharmacy.id }}"
                                  class="btn btn-primary btn-sm me-2 mb-2">Outsource Token Calls</router-link>
                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                 v-if="pharmacy.status == 1" @click="changePharmacyStatus(pharmacy.id, 2)" >Unpublish</b-button>
                                 <b-button variant="success" class="btn-sm me-2 mb-2"
                                 v-if="pharmacy.status == 2" @click="changePharmacyStatus(pharmacy.id, 1)" >Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                  @click="pharmacyDelete(pharmacy)" >Delete</b-button>
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No pharmacies found</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->   
                  <caption v-if="Boolean(pharmacies.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchPharmacies(page.url + '&limit='+ limit + '&status=' + status + '&keyword=' + keyword)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

              

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
